import gql from 'graphql-tag';

export default gql`
fragment ProductAttributeListItem on ProductAttribute {
    id
    name
    code
    filterable
    is_active
    type
}
`;


// WEBPACK FOOTER //
// ./src/api/graphql/fragments/ProductAttributeListItem.ts